import React from 'react'

function TenderTextLGUMMLB() {
  return (
    <embed src="\pdfs\DAT2.5.2.2_LG-UM-M-LB_Dezentrales_Lueftungsgeraet_fuer_Mischlueftung-liegend_kr_NEU.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextLGUMMLB